/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * String for identifying the entity that is querying the audit-data (INTERNAL\/EXTERNAL) INTERNAL->Passport |
 * EXTERNAL->CarrierLogistics
 **/
export var QueriedBy;
(function (QueriedBy) {
    QueriedBy["INTERNAL"] = "INTERNAL";
    QueriedBy["EXTERNAL"] = "EXTERNAL";
})(QueriedBy || (QueriedBy = {}));
